import { apiClient } from './client';
export const companiesApi = {
    getBrand: (companyId) => apiClient.get(`/api/companies/${companyId}/brand`),
    search: (searchTerm, maxResults = 25, signal) => {
        if (searchTerm.length < 3) {
            const resp = { data: [], status: 200, statusText: 'OK' };
            return Promise.resolve(resp);
        }
        const qs = `searchTerm=${encodeURIComponent(searchTerm)}&maxResults=${maxResults}`;
        return apiClient.get(`/api/companies/search?${qs}`, { signal });
    },
    enrichByLinkedInId: (linkedInIdOrUrl) => {
        const trimmed = linkedInIdOrUrl.trim();
        // Check if it's a URL (contains linkedin.com/company/)
        if (trimmed.includes('linkedin.com/company/')) {
            const qs = `linkedInCompanyUrl=${encodeURIComponent(trimmed)}`;
            return apiClient.post(`/api/companies/enrich?${qs}`, {});
        }
        // Otherwise treat as LinkedIn company ID
        const qs = `linkedInCompanyId=${encodeURIComponent(trimmed)}`;
        return apiClient.post(`/api/companies/enrich?${qs}`, {});
    }
};
